import {
    fileTypeWord,
    fileTypePDFs,
    fileTypeExcel,
    fileTypePowerPoint,
    fileTypeText,
    fileTypeEmail,
    fileTypeVisio,
    fileTypeAudio,
    fileTypeXml,
    imagesScopeText,
    filesScopeText,
    allFilesText,
    photosText,
} from './getFileExtensionData.locstring.json';
import loc from 'owa-localize';
import { FileExtensionData } from '../schema/FileExtensionData';
import { FileExtensionType } from '../schema/FileExtensionType';
import { assertNever } from 'owa-assert';
import { getFileIconFromSprite } from 'owa-file-icon';
import { isFeatureEnabled } from 'owa-feature-flags';

// TODO: VSO# 40353: See if more extension need to be added
export function getFileExtensionData(extensionType: FileExtensionType): FileExtensionData {
    /**
     * The function is necessary so that the LOC strings are resolved when the UI uses it
     */
    switch (extensionType) {
        case FileExtensionType.Documents:
            return {
                type: FileExtensionType.Documents,
                text: loc(fileTypeWord),
                extensions: ['doc', 'docm', 'docx', 'dot', 'dotm', 'dotx', 'odt'],
                icon: getFileIconFromSprite('docx'),
            };
        case FileExtensionType.PDFs:
            return {
                type: FileExtensionType.PDFs,
                text: loc(fileTypePDFs),
                extensions: ['pdf'],
                icon: getFileIconFromSprite('pdf'),
            };
        case FileExtensionType.Spreadsheets:
            return {
                type: FileExtensionType.Spreadsheets,
                text: loc(fileTypeExcel),
                extensions: ['xls', 'xlsb', 'xlsm', 'xlsx', 'ods', 'csv'],
                icon: getFileIconFromSprite('xlsx'),
            };
        case FileExtensionType.PowerPoint:
            return {
                type: FileExtensionType.PowerPoint,
                text: loc(fileTypePowerPoint),
                extensions: [
                    'ppt',
                    'pptm',
                    'pptx',
                    'pot',
                    'potm',
                    'potx',
                    'odp',
                    'pps',
                    'ppsx',
                    'ppsm',
                ],
                icon: getFileIconFromSprite('pptx'),
            };
        case FileExtensionType.Text:
            return {
                type: FileExtensionType.Text,
                text: loc(fileTypeText),
                extensions: ['txt', 'rtf'],
                icon: getFileIconFromSprite('txt'),
            };
        case FileExtensionType.Email:
            return {
                type: FileExtensionType.Email,
                text: loc(fileTypeEmail),
                extensions: ['msg', 'eml'],
                icon: getFileIconFromSprite('email'),
            };
        case FileExtensionType.Visio:
            return {
                type: FileExtensionType.Visio,
                text: loc(fileTypeVisio),
                extensions: ['vsd', 'vsdm', 'vsdx'],
                icon: getFileIconFromSprite('vsdx'),
            };
        case FileExtensionType.Audio:
            return {
                type: FileExtensionType.Audio,
                text: loc(fileTypeAudio),
                extensions: ['mp3'],
                icon: getFileIconFromSprite('audio'),
            };
        case FileExtensionType.Xml:
            return {
                type: FileExtensionType.Xml,
                text: loc(fileTypeXml),
                extensions: ['xml'],
                icon: getFileIconFromSprite('code'),
            };
        case FileExtensionType.Images:
            /*
                THIS IS THE DEFAULT FILE EXTENSION FILTER FOR PHOTOHUB. ANY CHANGE TO THIS
                HAS AN IMPACT ON HOW WE WARMUP THE FILES FOLDER ON 1ST EXPERIENCE.
                IF ANYTHING CHANGES ON THIS ARRAY, A CHANGE IS ALSO NEEDED AT GetItemViewQueryFilter ON
                Utah1\sources\dev\data\src\ApplicationLogic\Server\DefaultViewIndexer\PhotoHubFlightConfiguration.cs

                The order of the extensions are flipped in relation to those warmed up by the assistant (in FilesHubFlightConfiguration)
                because the server flips the order of the extensions when the the GetAttachmentItems request is made.
                filterConverter converts the restricions, see GetAttachmentItems:
                /sources/dev/clients/src/Owa2/Server/Core/ServiceCommands/GetAttachmentItems.cs
            */
            return {
                type: FileExtensionType.Images,
                text: isFeatureEnabled('doc-fileshub-combineFilesandImages')
                    ? loc(photosText)
                    : loc(imagesScopeText),
                extensions: [
                    'tif',
                    'tiff',
                    'psd',
                    'dib',
                    'jfif',
                    'jpe',
                    'bmp',
                    'gif',
                    'jpg',
                    'jpeg',
                    'png',
                ],
                icon: getFileIconFromSprite('photo'),
            };
        case FileExtensionType.Files:
            /*
                THIS IS THE DEFAULT FILE EXTENSION FILTER FOR FILESHUB. ANY CHANGE TO THIS
                HAS AN IMPACT ON HOW WE WARMUP THE FILES FOLDER ON 1ST EXPERIENCE.
                IF ANYTHING CHANGES ON THIS ARRAY, A CHANGE IS ALSO NEEDED AT GetItemViewQueryFilter ON
                Utah1\sources\dev\data\src\ApplicationLogic\Server\DefaultViewIndexer\FilesHubFlightConfiguration.cs

                The order of the extensions are flipped in relation to those warmed up by the assistant (in FilesHubFlightConfiguration)
                because the server flips the order of the extensions when the the GetAttachmentItems request is made.
                filterConverter converts the restricions, see GetAttachmentItems:
                /sources/dev/clients/src/Owa2/Server/Core/ServiceCommands/GetAttachmentItems.cs
            */
            return {
                type: FileExtensionType.Files,
                text: isFeatureEnabled('doc-fileshub-combineFilesandImages')
                    ? loc(allFilesText)
                    : loc(filesScopeText),
                extensions: [
                    'txt',
                    'xml',
                    'mp3',
                    'rtf',
                    'odt',
                    'dotx',
                    'dotm',
                    'dot',
                    'docx',
                    'docm',
                    'doc',
                    'vsdx',
                    'vsdm',
                    'vsd',
                    'pptx',
                    'pptm',
                    'ppt',
                    'ppsx',
                    'ppsm',
                    'pps',
                    'potx',
                    'potm',
                    'pot',
                    'odp',
                    'xlsx',
                    'xlsm',
                    'xlsb',
                    'xls',
                    'ods',
                    'csv',
                    'msg',
                    'eml',
                    'pdf',
                ],
            };
        default:
            return assertNever(extensionType);
    }
}
